import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'clear-all', 'ClearAll', [["path",{"d":"M8 6h12"}],["path",{"d":"M6 12h12"}],["path",{"d":"M4 18h12"}]]);